import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECURE_KEY || "default_key";

const getRandomString = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const storeData = (key, value) => {
  if (typeof value !== "string") {
    value = JSON.stringify(value);
  }
  if (value.length === 1) {
    value = value + "___" + getRandomString(10);
  }
  const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
  window.localStorage.setItem(key, encrypted);
};

export const getData = (key) => {
  const encrypted = window.localStorage.getItem(key);
  if (!encrypted) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    let decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (decrypted.includes("___")) {
      decrypted = decrypted.split("___")[0];
    }
    return decrypted;
  } catch {
    return null;
  }
};
